import React from 'react';
import styled from 'styled-components';
import { loading, pulse } from 'styles/animations';

export const Spinner = styled.div`
  color: #ffffff;
  font-size: 20px;
  margin: 100px auto;
  width: 1em;
  height: 1em;
  border-radius: 50%;
  position: relative;
  text-indent: -9999em;
  -webkit-animation: ${loading} 1.3s infinite linear;
  animation: ${loading} 1.3s infinite linear;
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
`;

const BubblePulse = styled.div`
  width: 150px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: center;
  margin-top: 50px;
  div {
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background-color: white;
  }
  div:nth-child(1) {
    animation: ${pulse} .4s ease 0s infinite alternate;
  }
  div:nth-child(2) {
    animation: ${pulse} .4s ease .2s infinite alternate;
  }
  div:nth-child(3) {
    animation: ${pulse} .4s ease .4s infinite alternate;
  }
  div:nth-child(4) {
    animation: ${pulse} .4s ease .6s infinite alternate;
  }
`;

export const BubblePulseLoader = () => (
  <BubblePulse>
    <div /><div /><div /><div />
  </BubblePulse>
);
